// @flow

import type { UserState } from "./types";
import { startRequest, finishRequest } from "@store/utils";

export const setLoading = (state: UserState) => () => startRequest(state);

export const onGetLoggedUserDashboardOverviewSuccess = (state: UserState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: null,
  overview: {
    ...state.overview,
    ...payload,
  },
});

export const onGetLoggedUserDashboardOverviewError = (state: UserState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: payload,
  };
};
